export default __webpack_public_path__ + "static/media/5.cb0a5c84.png";